<div class="containerMarginX tech-content">
  <div
    class="card-white item pointer"
    *ngFor="let item of items"
    routerLink="{{ item.url }}"
  >
    <span class="item-icon">
      <fa-icon [icon]="[item.iconType, item.icon]"></fa-icon>
    </span>
    <div>
      <div class="item-label">{{ item.label | translate }}</div>
      <div class="item-description">{{ item.description | translate }}</div>
    </div>
  </div>
</div>

<div class="tech-spacer"></div>

<div class="container-logout">
  <button mat-button (click)="commonService.goLogout()">
    <fa-icon [icon]="['fal', 'sign-out-alt']"></fa-icon>
    <span class="label">{{ 'k000257' | translate }}</span>
  </button>
</div>
